import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { media } from '../../styles_js/variables';
import { ScrollTopInjector } from '../ScrollTopInjector/ScrollTopInjector';

export const FixedContainerSt = styled.div`
  ${props =>
    props.hasOverlay &&
    css`
      position: fixed;
      overflow: hidden;
      width: 100%;
      height: 100vh;
    `};

  ${media.md(css`
    ${props =>
      props.hasOverlay &&
      css`
        top: 0;
        position: absolute;
        height: calc(${props.scrolled}px + 100vh);
      `};
  `)};
`;

export class FixedPositionInjector extends React.PureComponent {
  render() {
    const { hasOverlay, children } = this.props;

    return (
      <ScrollTopInjector>
        <FixedContainerSt hasOverlay={hasOverlay}>{children}</FixedContainerSt>
      </ScrollTopInjector>
    );
  }
}

FixedPositionInjector.propTypes = {
  hasOverlay: PropTypes.bool,
  children: PropTypes.any,
};

FixedPositionInjector.defaultProps = {
  children: null,
  hasOverlay: false,
};
